module.exports = __webpack_public_path__ + "static/media/about-yerevan.acd0f2f9.jpg";